import { Shop } from 'shop/pages'
import {
  AppContentLoader,
  CartLoader,
  LoaderSwitcher,
  PartnerStoreLoader
} from 'router/loaders'
import { useEffect } from 'react'
import { useQueryParams, useShop } from 'shop/hooks'
import { hasFulfillmentType } from 'shop/utils/common'
import { FulfillmentType } from 'shop/types'

export const ShopWrapper = (props: { slug: string }) => {
  const { currentPartnerStore } = useShop()
  const { getQueryParam, deleteQueryParam } = useQueryParams()

  const queryParamFulfillmentType =
    (getQueryParam('fulfillment_type').toUpperCase() as FulfillmentType) ||
    undefined

  /** Checks if fulfillment_type parameter is available for that store, if not remove query param */
  useEffect(() => {
    if (queryParamFulfillmentType && currentPartnerStore) {
      const orderFulfillmentTypeActive = hasFulfillmentType(
        currentPartnerStore,
        queryParamFulfillmentType
      )
      if (!orderFulfillmentTypeActive) {
        deleteQueryParam('fulfillment_type')
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPartnerStore?.orderFulfillmentTypes, queryParamFulfillmentType])

  return (
    <AppContentLoader>
      {(isParentLoaded) => (
        <PartnerStoreLoader
          storeSlug={props.slug}
          isParentLoaded={isParentLoaded}
        >
          {(isParentLoaded) => (
            <CartLoader isParentLoaded={isParentLoaded}>
              {(isParentLoaded) => (
                <LoaderSwitcher isParentLoaded={isParentLoaded}>
                  <Shop {...props} />
                </LoaderSwitcher>
              )}
            </CartLoader>
          )}
        </PartnerStoreLoader>
      )}
    </AppContentLoader>
  )
}
